import { useCallback, useState } from "react";
import { getPartnerProducts } from "../../../components/products/functions";
import { useStableSearch } from "../../hooks/useStableSearch";

const DEFAULT_FILTERS = {
  q: "",
  id: "",
  status: [],
};

export function usePartnerProductsSearch(user) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const runSearch = useCallback(async ({ token, filters: activeFilters, isCurrent }) => {
    setLoading(true);
    setError(null);

    const { q, id, status } = activeFilters;
    const statusParam =
      Array.isArray(status) && status.length > 0 ? status : status || undefined;

    const data = await getPartnerProducts(token, undefined, id, statusParam, q);

    if (!isCurrent()) {
      return;
    }

    if (data?.type === "error") {
      setError(data);
      setProducts([]);
    } else if (data?.type === "success") {
      setProducts(Array.isArray(data.data) ? data.data : []);
    } else {
      setProducts(Array.isArray(data) ? data : []);
    }

    setLoading(false);
  }, []);

  const search = useStableSearch(user?.token, filters, runSearch);
  const refresh = useCallback(() => search(), [search]);

  return { products, loading, error, filters, setFilters, search, refresh };
}
